module.exports = __webpack_public_path__ + "static/media/image 58.9d76babf.png";